export default __webpack_public_path__ + "static/media/brush-hr.45906bd3.svg";